var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsEnum, IsNumber, IsObject, IsOptional, IsString, IsUUID, } from 'class-validator';
import { PainLocationType } from '../enums/pain-location-type.enum.js';
import { AnamnesisLiteDto } from './anamnesis.lite.dto.js';
export class PainLocationFullSizeDto {
    id;
    createdAt;
    updatedAt;
    anamnesisId;
    anamnesis;
    painLocationType;
    customTitle;
    positionX;
    positionY;
    positionZ;
    isSelected;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PainLocationFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PainLocationFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PainLocationFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], PainLocationFullSizeDto.prototype, "anamnesisId", void 0);
__decorate([
    IsObject(),
    Type(() => AnamnesisLiteDto),
    Exclude(),
    __metadata("design:type", Function)
], PainLocationFullSizeDto.prototype, "anamnesis", void 0);
__decorate([
    IsEnum(PainLocationType),
    Expose(),
    __metadata("design:type", String)
], PainLocationFullSizeDto.prototype, "painLocationType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], PainLocationFullSizeDto.prototype, "customTitle", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PainLocationFullSizeDto.prototype, "positionX", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PainLocationFullSizeDto.prototype, "positionY", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], PainLocationFullSizeDto.prototype, "positionZ", void 0);
//# sourceMappingURL=pain-location.full-size.dto.js.map